import { exhaustMap } from 'rxjs';
import { inject } from '@angular/core';
import { FuelSpecsService } from '@navstation-portal/fuel-specs/data-access/service';
import { FuelSpecsStoreState } from '@navstation-portal/fuel-specs/data-model/fuel-spec';
import { mapResponse } from '@ngrx/operators';
import { signalStoreFeature, type } from '@ngrx/signals';
import { Events, withEventHandlers } from '@ngrx/signals/events';
import { fuelSpecsEvents } from './fuel-specs-events';

export function withFuelSpecsEffects() {
  return signalStoreFeature(
    type<{ state: FuelSpecsStoreState }>(),
    withEventHandlers(() => {
      const events = inject(Events);
      const fuelSpecsService = inject(FuelSpecsService);
      return {
        fetchDefaultFuelSpecs$: events.on(fuelSpecsEvents.fetchDefaultFuelSpecs).pipe(
          exhaustMap(() =>
            fuelSpecsService.getDefaultFuelSpecs().pipe(
              mapResponse({
                next: ({ data: fuelSpecs }) => {
                  return fuelSpecsEvents.fetchDefaultFuelSpecsSuccess(fuelSpecs);
                },
                error: (err: Error) => fuelSpecsEvents.fetchDefaultFuelSpecsFailed(err),
              })
            )
          )
        ),
      };
    })
  );
}
